import { jwtDecode } from 'jwt-decode'
import { UUID } from 'crypto'
import { getCookie } from './cookies'
import { UserAuthTokens, UserIdentity } from './types/domain'
import configuration from './configuration'

const getSessionCookieNameForEnv = (cookieName: string): string => {
  const environment = configuration.ENV
  if (environment !== 'production' && environment !== undefined) {
    return environment.slice(0, 3).concat('_', cookieName)
  }
  return cookieName
}

export const CookieName = {
  IdToken: getSessionCookieNameForEnv('p_id'),
} as const

export const getIdToken = (): string | undefined =>
  getCookie(CookieName.IdToken)

export const getUserInfo = (): UserIdentity | null => {
  const idToken = getIdToken()
  if (!idToken) return null

  return jwtDecode(idToken) as UserIdentity
}

export const getUserSub = (): UUID | undefined => {
  const data = getUserInfo()
  return data === null ? undefined : data.sub
}

// TEMPORAL - remove some weeks after ending July 25
export const getDeprecatedUserSession = (): UserAuthTokens | null => {
  const idToken = window.localStorage.getItem('payper_id_token')
  const accessToken = window.localStorage.getItem('payper_access_token')
  const accessTokenExpiresAt = window.localStorage.getItem(
    'payper_access_token_expiration_timestamp',
  )

  if (!idToken || !accessToken || !accessTokenExpiresAt) {
    return null
  }

  return {
    idToken,
    accessToken,
    accessTokenExpiresAt: parseInt(accessTokenExpiresAt),
  }
}

// TEMPORAL - remove some weeks after ending July 25
export const clearDeprecatedSession = (): void => {
  window.localStorage.removeItem('payper_id_token')
  window.localStorage.removeItem('payper_access_token')
  window.localStorage.removeItem('payper_access_token_expiration_timestamp')
}
